import { render, staticRenderFns } from "./sales-order-table.vue?vue&type=template&id=c79a790e&scoped=true&"
import script from "./sales-order-table.vue?vue&type=script&lang=js&"
export * from "./sales-order-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a790e",
  null
  
)

export default component.exports